export default {"src":"/_next/static/media/xero-logo-icon.402c2818.svg","height":24,"width":24};